import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";

function Event() {
  const { t } = useI18n();

  return (

    <>
      <>
        <Header />
        <>
          {/* Page Header Section Start */}
          <div className="page-header bg-section parallaxie">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  {/* Page Header Box Start */}
                  <div className="page-header-box">
                    <h1 className="text-anime-style-3" data-cursor="-opaque">
                      {t('pages.event')}
                    </h1>

                  </div>
                  {/* Page Header Box End */}
                </div>
              </div>
            </div>
          </div>
          {/* Page Header Section End */}

          {/* Page Team Single Start */}
          <div className="page-team-single">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  {/* Page Team Single Box Start */}
                  <div className="page-team-single-box">
                    {/* Team Member About Box Start */}
                    <div className="team-member-about-box">
                      {/* Team Single Image Start */}
                      <div className="team-single-image">
                        <figure className="image-anime ">
                          <img src="images/Untitled design (28).png" alt="" />
                        </figure>
                      </div>
                      {/* Team Single Image End */}
                      {/* Member About Content Start */}
                      <div className="member-about-content">
                        {/* Section Title Start */}
                        <div className="section-title">
                          <h2 className="text-anime-style-3" data-cursor="-opaque">
                            {t('pages.eventTitle')}
                          </h2>
                          <p className="wow fadeInUp" data-wow-delay="0.2s">{t('pages.eventP1')}</p>

                          <p className="wow fadeInUp" data-wow-delay="0.2s">{t('pages.eventP2')}</p>

                          <p className="wow fadeInUp" data-wow-delay="0.2s">{t('pages.eventP3')}</p>
                          <div className="mt-3">
                            <button
                              className="btn-default btn-highlighted"
                              onClick={() => {
                                try {
                                  const evt = typeof window.CustomEvent === 'function' ? new CustomEvent('open-registration') : new Event('open-registration');
                                  window.dispatchEvent(evt);
                                } catch (e) {
                                  // very old browsers: fallback to createEvent
                                  const evt = document.createEvent('Event');
                                  evt.initEvent('open-registration', true, true);
                                  window.dispatchEvent(evt);
                                }
                              }}
                            >
                              {t('header.registerYourParticipation')}
                            </button>
                          </div>
                        </div>
                        {/* Section Title End */}
                   
                      
                      </div>
                      {/* Member About Content End */}
                    </div>
                    {/* Team Member About Box End */}
                
                  </div>
                  {/* Page Team Single Box End */}
                </div>
              </div>
            </div>
          </div>
          {/* Page Team Single End */}



        </>


        <Footer />
      </>

    </>
  );
}

export default Event;